import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NotificationsService } from './notifications.service';
import { Notification, NotificationType } from './notification';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'notifications',
  template: `
    <div class="container">
      @for (n of notificationsService.notifications; track n) {
        <div
          (click)="removeNotification(n)"
          class="notification"
          [class.loading]="n.type === NotificationType.LOADING"
          [class.success]="n.type === NotificationType.SUCCESS"
          [class.info]="n.type === NotificationType.INFO"
          [class.warning]="n.type === NotificationType.WARNING"
          [class.error]="n.type === NotificationType.ERROR">
          {{ n.message }}
        </div>
        @if (n.type === NotificationType.LOADING) {
          <mat-progress-bar mode="indeterminate" />
        }
      }
    </div>
  `,
  styles: [
    `
      .container {
        left: 20px;
        top: 20px;
        position: fixed;
        z-index: calc(var(--z-index-max) - 10) !important;
        pointer-events: none;
      }

      .notification {
        color: white;
        border-radius: 5px;
        width: fit-content;
        width: -moz-fit-content;

        pointer-events: auto;
        cursor: pointer;

        padding-left: 1.25rem;
        padding-right: 1.25rem;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;

        margin-bottom: 0.5rem;
      }

      .loading {
        background-color: white;
        border: 1px solid grey;
        color: black;
        width: 200px;
        pointer-events: none;
      }

      .success {
        background-color: #00c851;
        border: 1px solid #007e33;
      }

      .info {
        background-color: #33b5e5;
        border: 1px solid #0099cc;
      }

      .warning {
        background-color: #ffbb33;
        border: 1px solid #ff8800;
      }

      .error {
        background-color: #ff4444;
        border: 1px solid #cc0000;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressBar],
})
export class NotificationsComponent {
  notificationsService = inject(NotificationsService);

  readonly NotificationType = NotificationType;

  removeNotification(n: Notification) {
    if (n.type === NotificationType.LOADING) {
      return;
    }

    this.notificationsService.notifications.splice(
      this.notificationsService.notifications.indexOf(n),
      1,
    );
  }
}
